<template>
	<div class="page-container">
		<h1>Review Plan</h1>
		<div :class="['table-content', { 'is-blur-disabled': showUpdateConfirm }]">
			<InputSrTableCustom
				v-model="table"
				:titlePageAuthors="Authors"
				@authChangeHandler="authorHandler"
			></InputSrTableCustom>
		</div>
		<div v-if="showUpdateConfirm" class="modal-overlay">
			<div class="modal-card">
				<h3>Update Detected</h3>
				<p class="modal-text">
					A new version of the Review Plan is available. It is easier to follow
					and has a reduced number of tasks and rows. Would you like to update
					to the new version, although this may mean losing some of your task
					list?
				</p>
				<div class="modal-actions">
					<button class="btn btn-secondary" @click="keepOld">
						Keep Old Version
					</button>
					<button class="btn btn-primary" @click="acceptUpdate">
						Update to Latest
					</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import InputSrTableCustom from "@/components/InputSrTableCustom.vue";
export default {
	components: {
		InputSrTableCustom
	},
	data() {
		return {
			showUpdateConfirm: false,
			taskPeopleInvolvedInit: {
				"Design systematic search strategy": "searchStrategyAuthors",
				"Run systematic search strings": "searchStrategyAuthors",
				"Deduplicate results": "searchStrategyAuthors",
				"Citation search": "conductSSearchAuthors",
				"Screen abstracts": "titleAbstractScreeners",
				"Obtain full text": "fullTextRetrivalAuthor",
				"Screen full text": "fullTextScreeners",
				"Screen trial registries": "screenTrialRegisPeople",
				"Screen citation analysis": "screenCitationSearchPeople",
				"Extract data": "extractionAuthors",
				"Risk of Bias assessment": "assessedRobAuthors"
			}
		};
	},
	created() {
		this.initializeTable();
		this.syncAuthorSelections();
		[...new Set(Object.values(this.taskPeopleInvolvedInit))].forEach(key => {
			this.$watch(
				() => this.$tera.project[key],
				() => this.syncAuthorSelections(),
				{ deep: true }
			);
		});
	},
	computed: {
		table: {
			get() {
				return this.$tera.project.planTable;
			},
			set(newValue) {
				if (newValue && typeof newValue === "object") {
					this.$tera.project.planTable = newValue;
				}
			}
		},
		Authors() {
			let da = [];
			if (
				//check if authors are initialized
				this.$tera.project.author != undefined &&
				this.$tera.project.acknowledgements != undefined
			) {
				da = [
					...this.$tera.project.author,
					...this.$tera.project.acknowledgements
				];
				da = this.checkUnion(
					da.map(el => {
						return { label: el };
					})
				);
			}
			console.log("daaa:" + JSON.stringify(da));
			return da;
		}
	},
	methods: {
		initializeTable() {
			//const updatedTable = this.$tera.project.ReviewWizardUpdatedTable?.version;
			const updateTime = this.$tera.project.ReviewWizardUpdatedTable?.date;
			// Has update version
			if (
				updateTime &&
				new Date(this.$tera.project.tableCreateTime) < new Date(updateTime)
			) {
				this.showUpdateConfirm = true;
			}
		},
		keepOld() {
			this.$tera.project.tableCreateTime = new Date();
			this.showUpdateConfirm = false;
			//console.log("keepOld", this.$tera.project);
		},
		acceptUpdate() {
			const latestTableData = this.$tera.project.ReviewWizardUpdatedTable;

			if (latestTableData) {
				this.$tera.project.planTable = latestTableData.version;
				this.$tera.project.tableCreateTime = latestTableData.date;
			}
			//console.log("acceptUpdate", this.$tera.project);
			this.showUpdateConfirm = false;
		},
		authorHandler(ifadd, row, event) {
			if (row != null) {
				this.authorModify(ifadd, row, event);
				this.syncAuthorSelections();
			} else if (event != undefined) {
				return this.checkAuthorSelection(event);
			}
			return this.$tera.project.planTable;
		},
		syncAuthorSelections() {
			if (this.$tera.project.planTable) {
				this.checkAuthorSelection(this.$tera.project.planTable);
			}
		},
		checkUnion(U) {
			if (U.length > 0) {
				for (var i = 0; i < U.length; i++) {
					for (var j = i + 1; j < U.length; j++) {
						if (U[i].label == U[j].label) {
							U.splice(j, 1);
							j--;
						}
					}
				}
			}
			return U;
		},
		checkAuthorSelection(table) {
			//console.log("defaults:" + JSON.stringify(table));
			table.rows.forEach(el => {
				const projectPeopKey = this.taskPeopleInvolvedInit[el.tasks];

				if (projectPeopKey && this.$tera?.project?.[projectPeopKey] != null) {
					el.peopleInvolved = this.$tera.project[projectPeopKey];
				}
			});
			return table;
		},
		authorModify(ifadd, row, event) {
			if (!row || !row.tasks) return;

			const projectPeopKey = this.taskPeopleInvolvedInit[row.tasks];

			if (projectPeopKey) {
				const authorsArray = this.$tera?.project?.[projectPeopKey];

				if (Array.isArray(authorsArray)) {
					if (ifadd === 1) {
						if (!authorsArray.some(author => author.label === event.label)) {
							authorsArray.push(event);
						}
					} else {
						const index = authorsArray.indexOf(event);
						if (index !== -1) {
							authorsArray.splice(index, 1);
						}
					}
				}
			}
		}
	}
};
</script>

<style scoped>
.page-container {
	position: relative;
	width: 100%;
	min-height: 400px;
}

.table-content {
	transition: filter 0.3s ease, opacity 0.3s ease;
}

.is-blur-disabled {
	filter: blur(5px);
	pointer-events: none;
	user-select: none;
	opacity: 0.5;
}

.modal-overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background: rgba(15, 23, 42, 0.45);
	backdrop-filter: blur(8px);
	-webkit-backdrop-filter: blur(8px);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 1000;
	animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
	from { opacity: 0; }
	to { opacity: 1; }
}


.modal-card {
	background: #ffffff;
	padding: 36px 30px;
	border-radius: 16px;
	box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
	max-width: 440px;
	width: 90%;
	text-align: center;
	border: 1px solid rgba(226, 232, 240, 0.8);
	animation: scaleUp 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
	box-sizing: border-box;
}

@keyframes scaleUp {
	from {
		opacity: 0;
		transform: scale(0.95);
	}
	to {
		opacity: 1;
		transform: scale(1);
	}
}

.modal-card h3 {
	margin: 0 0 12px 0;
	color: #0f172a;
	font-size: 1.5rem;
	font-weight: 700;
	letter-spacing: -0.02em;
}

.modal-text {
	color: #475569;
	font-size: 0.95rem;
	line-height: 1.6;
	margin: 0 0 28px 0;
}

.modal-actions {
	display: flex;
	justify-content: stretch;
	gap: 12px;
}

.btn {
	padding: 10px 20px;
	border-radius: 8px;
	font-size: 0.9rem;
	font-weight: 600;
	cursor: pointer;
	height: 42px;
	transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
	display: inline-flex;
	align-items: center;
	justify-content: center;
	outline: none;
	width: 100%;
}

.btn-secondary {
	background-color: #ffffff;
	border: 1px solid #cbd5e1;
	color: #475569;
}
.btn-secondary:hover {
	background-color: #f8fafc;
	border-color: #94a3b8;
	color: #1e293b;
	transform: translateY(-1px);
}
.btn-secondary:active {
	transform: translateY(0);
}

.btn-primary {
	background: linear-gradient(135deg, #3b82f6, #2563eb);
	border: none;
	color: #ffffff;
	box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.2);
}
.btn-primary:hover {
	background: linear-gradient(135deg, #2563eb, #1d4ed8);
	box-shadow: 0 10px 15px -3px rgba(37, 99, 235, 0.3);
	transform: translateY(-1px);
}
.btn-primary:active {
	transform: translateY(0);
}
</style>
